export default {"src":"/_next/static/media/idea.af3a6a9d.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};